import all from './all';
import approved from './approved';

export default {
  all,
  approved,
};
